import { ReactNode } from "react";

interface CardBodyProps {
  body: ReactNode;
}

export const CardBody = ({ body }: CardBodyProps) => {
  if (!body) return null;

  return <div className="mt-2 text-sm">{body}</div>;
};
